const chat = {
  chat: 'Чат',
  sendMessage: 'Отправить сообщение',
  noMessagesYet: 'Здесь пока ничего нет...',
};

export default chat;
